module.exports = __webpack_public_path__ + "static/media/fhi-logo-hvit.73ef3445.svg";